import { render, staticRenderFns } from "./TournamentInfo.vue?vue&type=template&id=06187460&"
import script from "./TournamentInfo.vue?vue&type=script&lang=js&"
export * from "./TournamentInfo.vue?vue&type=script&lang=js&"
import style0 from "./TournamentInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports